import React from 'react';
import { useTranslation } from '@/i18n';
import { acquireCluster } from '@/utils';

const ModalContent: React.FC = () => {
  const { t } = useTranslation('i18n_ecom_shop_email');
  const isTTP = acquireCluster() === 'ttp';

  return (
    <>
      {isTTP
        ? t('description_on_email_popup_window', 'Submit your ticket')
        : t('help_center_new_ticket_submit_confirm_dialog_text', 'Submit the ticket?')}
    </>
  );
};

export default ModalContent;
